var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-form-input" }, [
    _c(
      "label",
      {
        staticClass: "c-form-input__label",
        class: _vm.requiredCssClass,
        attrs: { for: _vm.id }
      },
      [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]
    ),
    _vm._v(" "),
    _c(
      "input",
      _vm._b(
        {
          staticClass: "c-form-input__control",
          attrs: { id: _vm.id, type: _vm.type },
          domProps: { value: _vm.value },
          on: { input: _vm.updateValue }
        },
        "input",
        _vm.$attrs,
        false
      )
    ),
    _vm._v(" "),
    _vm.validationError
      ? _c(
          "span",
          {
            staticClass: "c-form-input__validation-message",
            attrs: { id: _vm.errorId }
          },
          [_vm._v("\n    " + _vm._s(_vm.renderError()) + "\n  ")]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-754cbf1a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-754cbf1a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/geneco/resources/form/elements/FormInput.vue
// module id = 568
// module chunks = 0